// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, signInAnonymously } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics'
import axios from 'axios'; // Import Axios for making HTTP requests
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCorGRZV-O-rm-0cszvmB80HPcmCcDoJLs",
  authDomain: "kb-company-website-a33e7.firebaseapp.com",
  projectId: "kb-company-website-a33e7",
  storageBucket: "kb-company-website-a33e7.firebasestorage.app",
  messagingSenderId: "61043414681",
  appId: "1:61043414681:web:bcfa88273d2c3b35950a08",
  measurementId: "G-XF35NTV7TG"
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth();
const db = getFirestore(app);

signInAnonymously(auth)
  .then(async (userCredential) => {
    const user = userCredential.user;
    const userId = user.uid;

    // Send tracking data to Firestore
    const trackingData = {
      userId: userId,
      page: 'Home', // Replace with the current page or screen name
      timestamp: serverTimestamp(),
    };

    const docRef = await addDoc(collection(db, 'userTracking'), trackingData);
    console.log('Tracking data added to Firestore with ID:', docRef.id);
  })
  .catch((error) => {
    console.error('Error signing in anonymously:', error);
  });
const sendEmail = async (to, subject, body) => {
  try {
    const emailData = {
      to: to, // Change the recipient email address
      subject: subject,
      body: body,
    };

    const response = await axios.post('https://api.kodeblue.in/actions/sendEmail', emailData, {
      headers: {
        'x-api-key': 'bzjSEkpOKy5lPPOo8zPOr3We59tKQlAGaJYOYkmz', // Change the API key
        'Content-Type': 'application/json',
      },
    });

    console.log(response.data);
    // Handle the response as needed
  } catch (error) {
    console.error(error);
    // Handle errors here
  }
};


// Export firestore database
// It will be imported into your react app whenever it is needed
export { db, auth, analytics, sendEmail };